
import { useState, useEffect } from "react"
import InfoBox from "../../ui/InfoBox"
import NewSeniorityForm from "./NewSeniorityForm"
import SavedClaimBox from "./SavedClaimBox"

export default function SeniorityClaimBox({
  claims,
  onChange,
  initialData
}: {
  claims?: any[]
  onChange?: (claims: any[]) => void
  initialData?: any[]
}) {

  const [isOpen, setIsOpen] = useState(false)
  const [savedClaims, setSavedClaims] = useState<any[]>([])
  const [editingClaim, setEditingClaim] = useState<any | null>(null)

  useEffect(() => {
    setSavedClaims(claims ?? [])
  }, [claims])

  useEffect(() => {
    if (initialData && initialData.length > 0) {
      setSavedClaims(initialData)
    }
  }, [initialData])

  const closeForm = () => {
    setIsOpen(false)
    setEditingClaim(null)
  }

  const pushUp = (updated: any[]) => {
    setSavedClaims(updated)
    if (onChange) onChange(updated)
  }

  const handleNewSubmit = (data: {
    type: string
    countryCode: string
    applicationNumber: string
    applicationDate: string
    registrationNumber: string
    registrationDate: string
    priorityDate?: string
    euipoDocumentId?: string | null
    originalFileName?: string | null
  }) => {

    const newClaim = {
      ...(editingClaim || {}),
      ...data,
      isImported: false,
      isDeleted: false
    }

    let updated

    if (editingClaim) {

      updated = savedClaims.map((c) =>
        c === editingClaim ? { ...newClaim } : c
      )

    } else {

      updated = [...savedClaims, newClaim]

    }

    pushUp(updated)
    closeForm()

  }

  return (

    <div className="flex flex-col gap-4">

      <div className="flex items-center gap-2">

        <h3 className="text-base font-semibold text-gray-800">
          Seniority claim
        </h3>

        <InfoBox title="Seniority claim">
          Seniority can be claimed from an identical national registration in a member state.
        </InfoBox>

      </div>

      <div
        onClick={() => {
          setEditingClaim(null)
          setIsOpen(true)
        }}
        className="border border-gray-300 hover:border-blue-400 rounded-md p-8 flex flex-col items-center justify-center bg-gray-50 cursor-pointer w-60 transition"
      >

        <div className="text-4xl text-gray-700 mb-2">
          +
        </div>

        <span className="text-sm font-medium text-gray-700">
          Add seniority claim
        </span>

      </div>

      {savedClaims.length > 0 && (

        <div className="flex flex-wrap gap-3">

          {savedClaims.map((claim, index) =>
            !claim.isDeleted && (

              <SavedClaimBox
                key={index}
                claim={claim}

                onEdit={() => {
                  setEditingClaim(claim)
                  setIsOpen(true)
                }}

                onDelete={() => {

                  const updated = savedClaims.map((c, i) =>
                    i === index ? { ...c, isDeleted: true } : c
                  )

                  pushUp(updated)

                }}

              />

            )
          )}

        </div>

      )}

      {isOpen && (

        <div className="relative border border-gray-200 rounded-md p-6 bg-white text-sm text-gray-700 space-y-4">

          <button
            type="button"
            onClick={closeForm}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-lg"
            aria-label="Close"
          >
            ×
          </button>

          <p className="font-semibold">
            {editingClaim
              ? "Edit your seniority claim"
              : "Create new seniority"}
          </p>

          <NewSeniorityForm
            key={editingClaim ? "edit" : "new"}
            onCancel={closeForm}
            onSubmit={handleNewSubmit}
            initialData={editingClaim}
          />

        </div>

      )}

    </div>

  )

}
